import type { Filters } from "@modules/types"
import { isMobile } from "@modules/util/device"
import { debounce } from "lodash-es"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { fetchApiWithAllFilters } from "../api"
import { addCategory, removeCategory } from "../category"
import { addFilterGroupValue, getFilterContainerElement, getFilters, removeFilterGroupValue } from "../filter"
import { filterConfig } from "../filter-config"
import { resetPagination } from "../pagination/pagination"
import { handleSelectInputEvent, resetFilterSelects, updateFilterSelectInDom } from "./filter-selects"
import { updateFilterTabsInDomMobile } from "./filter-tabs"
import { setShowResultsButton, setShowResultsButtonLoading } from "./show-results-button"

export function updateFilterCheckboxes(filters: Filters) {
    resetFilterCheckboxes()
    resetFilterSelects()

    for (const [group, values] of Object.entries(filters)) {
        if (filterConfig.groups.select.includes(group)) {
            // select
            updateFilterSelectInDom(group)
        } else {
            // checkbox
            for (const value of values) {
                const checkbox = getFilterCheckboxInDom(group, value)
                if (checkbox) {
                    checkbox.checked = true
                } else {
                    console.warn("Checkbox not found while updating Filters in Dom", group, value)
                }
            }
        }
    }
}

export function resetFilterCheckboxes() {
    const elements = Array.from(document.querySelectorAll<HTMLInputElement>(".custom-checkbox input"))
    for (const element of elements) {
        // ignore categories
        if (element.getAttribute("data-seo-group") === "rubrik") {
            continue
        }
        element.checked = false
    }
}

export function getFilterCheckboxInDom(group: string, value: string) {
    return document.querySelector<HTMLInputElement>(`input[data-seo-group="${group}"][data-seo="${value}"]`)
}

export const handleFilterInputEvent = debounce(async (event: Event) => {
    const element = event.target as HTMLInputElement | HTMLSelectElement
    if (element.name === "address") {
        return
    }

    if (element.type === "checkbox") {
        handleCheckboxInputEvent(element)
    } else if (element instanceof HTMLSelectElement) {
        handleSelectInputEvent(element)
    } else {
        return // dont rerender filter
    }

    resetPagination()
    setShowResultsButtonLoading()

    const result = await fetchApiWithAllFilters()
    // mobile only update count inside button
    updateFilterTabsInDomMobile()
    setShowResultsButton(result?.advertCount || 0)

    if (isMobile()) {
        return
    }

    afterFilterApiFetched(result)
}, filterConfig.apiFetchDebounceMs)

const handleCheckboxInputEvent = (element: HTMLInputElement) => {
    const group = element.getAttribute("data-seo-group") as string
    const value = element.getAttribute("data-seo") as string

    if (group === "rubrik") {
        element.checked ? addCategory(value) : removeCategory(value)
        return
    }

    element.checked ? addFilterGroupValue(group, value) : removeFilterGroupValue(group, value)
}

getFilterContainerElement()?.addEventListener("change", handleFilterInputEvent)
updateFilterCheckboxes(getFilters())
